import {
  BMComponentsType,
  BMPrimitives,
  BMSkeletonLoader,
  BMText,
  useBMTheme,
} from "@traveloka/district-bloom";
import IcContactMail from "@traveloka/icon-kit-web/react/IcContactMail";
import { StyleSheet } from "react-native";

import { memo, useMemo } from "react";
import { BMPhoneNumberField, PhoneFieldValue } from "../../../../components";
import BMView from "../../../../components/View/BMView";
import { useMobileContentResource } from "../../../../core/resource/MobileResourceProvider";

type Props = {
  fullname?: string;
  email?: string;
  phone?: PhoneFieldValue | null;
  error?: string;
  onChangePhone: (phone: PhoneFieldValue | null) => void;
};

/**
 * @see HotelPrebookContactDetails
 * @todo Revisit to ensure consistent design and
 * component usage across all product prebook forms.
 */
function FlightPrebookContactDetails({
  email,
  phone,
  fullname,
  error,
  onChangePhone,
}: Props) {
  const { BMComponents } = useBMTheme();
  const styles = useMemo(() => createStyles(BMComponents), [BMComponents]);

  const { CorporateFlightPrebookForm: cr } = useMobileContentResource();
  return (
    <BMView spacing="md">
      <BMView>
        <BMText variant="uiHuge">{cr.contactFormTitle}</BMText>
        <BMText variant="paragraphSmall" ink="BMStyleTextInkSecondary">
          {cr.contactFormSubtitle}
        </BMText>
      </BMView>
      <BMView style={styles.container}>
        <BMView style={[styles.content, styles.contact]} spacing="sm">
          {fullname ? (
            <BMText variant="uiNormal">{fullname}</BMText>
          ) : (
            <BMSkeletonLoader height={18} width={100} />
          )}
          {email ? (
            <BMView row spacing="xs" align="center">
              <IcContactMail
                width={16}
                height={16}
                color={BMComponents.BMStyleIconInkSecondary}
              />
              <BMText variant="uiNormal">{email}</BMText>
            </BMView>
          ) : (
            <BMSkeletonLoader height={18} width={150} />
          )}
        </BMView>
        <BMView style={styles.content} spacing="sm">
          <BMPhoneNumberField
            value={phone || null}
            onChange={onChangePhone}
            prefixOptions={{
              label: cr.contactFormPhonePrefixLabel,
              placeholder: cr.contactFormPhonePrefixPlaceholder,
            }}
            phoneOptions={{
              label: cr.contactFormPhoneNumberLabel,
              placeholder: cr.contactFormPhoneNumberPlaceholder,
            }}
            caption={cr.contactFormCaption}
            error={error}
          />
        </BMView>
      </BMView>
    </BMView>
  );
}

export default memo(FlightPrebookContactDetails);

function createStyles(BMComponents: BMComponentsType) {
  return StyleSheet.create({
    container: {
      borderRadius: BMPrimitives.BMRadius.md,
      borderWidth: BMPrimitives.BMBorder.width.thick,
      borderColor: BMComponents.BMStyleLineBordercolorSubtle,
    },
    content: {
      padding: BMPrimitives.BMSize.md,
    },
    contact: {
      borderBottomWidth: BMPrimitives.BMBorder.width.thick,
      borderColor: BMComponents.BMStyleLineBordercolorSubtle,
    },
  });
}
